<template lang="pug">
  .job-menu(:class="{ active: checked || isUploaded || isUploading }")
    p(v-if="checkedCount > 0")
      span(v-if="spMode") {{ checkedCount }}件のリストを選択
      span(v-else) {{ checkedCount }}件のリストを一覧から選択しています。
      span
        a(@click="uncheckAll") チェック解除
    p.more-dl-message(v-if="checkedCount > 0")
      | 1度のダウンロードは1,000件までできます
    ul
      li
        a.only-pc.button-sub(
          v-if="checkedCount > 0"
          @click="openCsvDownloadModal"
          :disabled="disabled"
        ) ダウンロード
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { HumanErrorMessages } from '../../constants'

export default {
  computed: {
    ...mapGetters('jobList', ['checked', 'checkedCount', 'checkedIds']),
    ...mapGetters('common', ['spMode', 'downloading']),
    ...mapGetters('user', ['demo']),
    ...mapGetters('uploadArchive', ['isUploading', 'isUploaded']),
    ...mapGetters({ locked: 'common/isGlobalLocked' }),
    disabled () {
      return this.locked || this.downloading
    },
  },
  async mounted () {
    try {
      await this.$store.dispatch('uploadArchive/fetchLatest', { target: 'job_list' })
      if (this.isUploading) await this.$store.dispatch('uploadArchive/startWatch', { target: 'job_list' })
    } catch (e) {
      // 無視（必要なら toast）
    }
    if (this.isUploading) await this.$store.dispatch('uploadArchive/startWatch', { target: 'job_list' })
  },
  methods: {
    ...mapMutations('jobList', ['uncheckAll']),
    openCsvDownloadModal () {
      this.$store.commit('job/copyCheckedIds', this.checkedIds)

      if (this.demo) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.FORBIDDEN),
        })
        return
      }
      if (this.isUploading) return

      if (this.checkedCount > 0) {
        this.$store.commit('common/setCsvTarget', 'job_list')
        this.$store.commit('common/setJobModalMode')
        this.$store.commit('common/showModal')
      }
    },
    async downloadFromS3 () {
      try {
        await this.$store.dispatch('uploadArchive/download', { target: 'job_list' })
      } catch (e) {
        await this.$store.dispatch('common/pushToastError', { error: e })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/parts/JobListMenu.vue